import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
import { sampleTech } from 'utils/constants';
var getHasSeuratTechnology = function getHasSeuratTechnology(experimentId) {
  return function (state) {
    var _state$experiments$ex;
    var sampleIds = ((_state$experiments$ex = state.experiments[experimentId]) === null || _state$experiments$ex === void 0 ? void 0 : _state$experiments$ex.sampleIds) || [];
    return sampleIds.some(function (sampleId) {
      var _state$samples$sample;
      return ((_state$samples$sample = state.samples[sampleId]) === null || _state$samples$sample === void 0 ? void 0 : _state$samples$sample.type) === sampleTech.SEURAT;
    });
  };
};
export default createMemoizedSelector(getHasSeuratTechnology);